import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, DecimalPipe, TitleCasePipe } from '@angular/common';

import { PerformanceContainerComponent } from './performance.container';
import { SharedModule } from '../../shared/shared.module';
import { ChartsModule } from '../../shared/charts/charts.module';
import { EffectsModule } from '@ngrx/effects';
import { PerformanceEffects } from './performance.effects';
import { PipesModule } from '../../global/pipes/pipes.module';
import { FieldModule } from 'atlas-field';
import { IconModule } from 'atlas-icon';
import { TableModule } from 'atlas-table';
import { CdkModule } from 'atlas-cdk';
import { LegacyModule } from 'atlas-legacy';
import { PaginationModule } from 'atlas-pagination';
import { TooltipModule } from 'atlas-tooltip';
import { MenuModule } from 'atlas-menu';
import { ListModule } from 'atlas-list';
import { LinkModule } from 'atlas-link';
export const COMPONENTS = [
  PerformanceContainerComponent,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    SharedModule,
    CommonModule,
    // // MercerOSModule,
    ChartsModule,
    FormsModule,
    PipesModule,
    FieldModule,
    IconModule,
    TableModule,
    CdkModule,
    LegacyModule,
    PaginationModule,
    TooltipModule,
    MenuModule,
    ListModule,
    LinkModule,
    EffectsModule.forFeature([PerformanceEffects])
  ],
  exports: COMPONENTS,
  providers: [DecimalPipe, TitleCasePipe],
  bootstrap: [],
})
export class PerformanceModule {
}
